<template>
  <BlocksCard class="blocks-listings-related" :class="{'__design': isDesign !== false}">
    <h2 class="__heading __underlined">
      You may be interested
    </h2>

    <div class="__listings-wrapper">
      <div v-for="(listing, key) in displayListings" :key="`listing-${key}`" style="max-width: 100%;">
        <LazyListingWidget v-if="listing.document.category !== 'Ad'" class="__listing" :listing="listing.document" :type="isDesign === false ? 'listing' : 'design'" :analytics-event-data="{displayedLocation: `related listings - ${route.path}`, position: (key as number) + 1}" />
        <AdWidget v-else-if="listing.document.category === 'Ad'" :listing="listing.document" :analytics-event-data="{displayedLocation: 'you_may_be_interested'}" />
      </div>
    </div>
  </BlocksCard>
</template>

<script lang="ts" setup>
import {Ref} from 'vue';
import {Listing, ListingHits, ListingType} from '~/@types/listing';
import {useNuxtApp, useRoute} from '#app';

const props = defineProps({
  listing: {
    type: [Object, null] as PropType<Listing | null>,
    default: null,
  },
  isDesign: {
    type: Boolean,
    default: false,
  },
  listingTypes: {
    type: [Array] as PropType<ListingType[]>,
    default: () => ['House & Land', 'Land', 'Showhome', 'Design', 'Ready to Move in', 'Turn Key', 'Affordable Housing', 'Investment', 'Terraced Housing', 'Apartment', 'Tiny Home', 'Transportable Home'],
  },
});
// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const {$listing} = useNuxtApp();
const listings: Ref<ListingHits[]> = ref([]);
const route = useRoute();
const {$ad} = useNuxtApp();
const selectedAd: Ref<any | null> = ref(null);

fetchAd();

onMounted(() => {
  initInterestedItems();
});

/**
 * Init interested items
 */
async function initInterestedItems () {
  let searchKeyword = '';
  let filterBy = 'isSold:=false && ';
  if (props.listing) {
    // searchKeyword = `${props.listing.bedrooms} beds ${props.listing.bathrooms} baths`;
    filterBy += props.isDesign === false ? `listingTypes:[${props.listing.listingTypes.data.join(',')}]` : 'listingTypes:=[Design]';
  } else {
    filterBy += `listingTypes:=[${props.listingTypes.join(',')}]`;
  }
  listings.value = await $listing.search(false, {
    searchKeyword,
    filterBy,
    hiddenHitDids: props.listing ? props.listing.did : '',
  });
}

const displayListings: Ref<ListingHits[]> = computed(() => {
  if (selectedAd.value) {
    return [...listings.value, selectedAd.value];
  }
  return listings.value;
});

/**
 * Fetch ad
 */
async function fetchAd () {
  try {
    const response = await $ad.search(['you_may_be_interested']);
    if (response?.hits && response.hits.length) {
      const randomIndex = Math.floor(Math.random() * response.hits.length);
      selectedAd.value = response.hits[randomIndex];
    }
  } catch (error: any) {
    console.log(error);
  }
}
</script>

<style lang="scss">
.blocks-listings-related {
  .__listings-wrapper {
    overflow: hidden;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    max-width: 100%;

    .blocks-listing {
      margin-bottom: 28px;
      box-shadow: unset;
      display: flex;
      border-radius: 8px unset unset 8px;
      flex-wrap:  nowrap;
      max-width: 100%;

      .__favorite-button-wrapper {
        left: 4px !important;
        top: 4px;
        width: fit-content;
      }

      .__listing-image-wrapper {
        width: 100px;
        height: 100px;
        border-radius: unset;

        .__listing-image {
          width: 100%;
          height: 100%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .__listing-type-wrapper {
          left: 0;
          bottom: 0;

          .__listing-type {
            padding: 2px 8px;
            font-size: 9px;
            text-align: left;
            border-top-left-radius: 0;
          }
        }
      }

      .__listing-info-wrapper {
        padding: 6px 0 0 16px;
        max-width: 240px;

        .__listing-title {
          font-size: 15px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .__listing-address-wrapper {
          padding: 8px 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: -16px;
          max-width: 210px;
          margin-bottom: -16px;
        }

        .__price {
          font-size: 12px;
        }

        .__builder-logo-wrapper {
          display: none;
        }

        .__listing-icon-info-block {
          .el-icon-button {
            margin-right: 5px;
            .__el-icon-button-inner {
              padding: 5px;

              img {
                width: 12px;
                height: auto;
              }
            }

            .__label {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  &.__design {
    .__listings-wrapper {
      .blocks-listing {
        .__listing-info-wrapper {
          .__builder-logo-wrapper {
            display: block !important;
            width: fit-content;
            height: fit-content;
            padding: 5px 0;

            a img {
              max-width: 40px;
              width: auto;
              height: auto;
              max-height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
